import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { Text } from '@vio/atlas/Text';
import { SplitBookingBundleType, SplitBookingOfferInfo } from 'components/Offer/types';
import { messages } from 'components/SplitBookings/messages';
import { Hotel } from 'modules/sapiSearch/slice';
import { SearchOffer } from '@daedalus/core/src/offer/types/SearchOffer';
import { RoomLabels } from '../RoomLabels';
import { SingleFlowBundleRoomLabels } from '../SingleFlowBundleRoomLabels/SingleFlowBundleRoomLabels';
const RoomLabelsWrapper = /*#__PURE__*/styled('span')({
  name: "RoomLabelsWrapper",
  class: "r1lztf4s",
  propsAsIs: false
});
const SingleFlowBundleRoomLabelsWrapper = /*#__PURE__*/styled('div')({
  name: "SingleFlowBundleRoomLabelsWrapper",
  class: "s3o2dtz",
  propsAsIs: false
});
interface MainProps {
  hasRoomLabels: boolean;
  isSplitBooking?: false;
  splitBookingOffers?: never;
  splitBookingType?: never;
  isYourChoice?: never;
  offer: SearchOffer;
  hotelId: Hotel['objectID'];
  isRequiredOneTimePasswordFlow?: boolean;
}
interface SplitBookingProps {
  hasRoomLabels: boolean;
  isSplitBooking?: true;
  splitBookingType: SplitBookingBundleType;
  splitBookingOffers: SplitBookingOfferInfo[];
  offer?: never;
  hotelId?: Hotel['objectID'];
  isRequiredOneTimePasswordFlow?: never;
}
export const RoomLabelsComponent: React.FC<MainProps | SplitBookingProps> = ({
  splitBookingType,
  splitBookingOffers,
  offer,
  hasRoomLabels = true,
  hotelId,
  isRequiredOneTimePasswordFlow = false
}) => {
  const {
    formatMessage
  } = useIntl();
  if (!hasRoomLabels) {
    return null;
  }
  if (splitBookingType === 'single_flow' && splitBookingOffers.length) {
    return <SingleFlowBundleRoomLabelsWrapper>
        <SingleFlowBundleRoomLabels offers={splitBookingOffers} hotelId={hotelId} />
      </SingleFlowBundleRoomLabelsWrapper>;
  }
  if (splitBookingType === 'split_flow') {
    return <Text variant="bodyXS" colorPath="content.neutral.c600">
        {formatMessage(messages.primaryOfferSubtitle)}
      </Text>;
  }
  return <RoomLabelsWrapper>
      <RoomLabels offer={offer} hotelId={hotelId} isRequiredOneTimePasswordFlow={isRequiredOneTimePasswordFlow} />
    </RoomLabelsWrapper>;
};

require("./RoomLabelsComponent.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomLabelsComponent.tsx");